import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {FaiControllerProvider} from "./context";
import PerfectScrollbar from "react-perfect-scrollbar";
import { registerServiceWorker } from "./utils/pwa";
import { watchForInstallPrompt } from "./utils/installApp";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <FaiControllerProvider>
              <PerfectScrollbar>
                  <App />
              </PerfectScrollbar>
          </FaiControllerProvider>
      </BrowserRouter>
  </React.StrictMode>
);

// Makes the dashboard installable on a phone and able to show shipment notifications.
registerServiceWorker();
// The browser offers the install only once per page load, so start listening before the app renders.
watchForInstallPrompt();
